export class HotkeyController {
    #host;
    #hotkeys;
    #onHotkey;
    constructor(host, { hotkeys, onHotkey, }) {
        this.#host = host;
        this.#hotkeys = hotkeys;
        this.#onHotkey = onHotkey;
        host.addController(this);
    }
    hostConnected;
    handleKeyDown = (keyDown) => {
        if (keyDown.repeat)
            return;
        const entries = Array.from(this.#hotkeys.entries());
        const activatedHotkey = entries.find(([hotkeyName, hotkey]) => hotkey.code === keyDown.code &&
            hotkey.modifiers.every((modifier) => keyDown[modifier]));
        if (!activatedHotkey)
            return;
        keyDown.preventDefault();
        keyDown.stopPropagation();
        const [hotkeyName] = activatedHotkey;
        this.#onHotkey(hotkeyName);
    };
}
